<template>
  <div>
    <DashboardHeader title="Secure Online Payment">
      <div v-if="studentProfile == 'not found'">
        <v-row>
          <v-alert type="warning" class="mx-auto my-15">
            <h3>No Student Data Found!</h3>
          </v-alert>
        </v-row>
      </div>
      <div v-else>
        <v-layout row wrap>
          <v-flex class="mx-4" xs12 md3>
            <Loader></Loader>
            <v-card
              class="mx-4 mt-10"
              v-if="studentProfile != null && student != null"
              shaped
              elevation="12"
              max-width="344"
              outlined
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="headline">Account #: {{student.sid}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="getThemeColor">mdi-credit-card</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{getCurrency}} {{openingBalance}}</v-list-item-title>
                    <v-list-item-subtitle>{{openingBalanceComment}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="getThemeColor">mdi-credit-card</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{getCurrency}} {{studentFinance.curfee}}</v-list-item-title>
                    <v-list-item-subtitle>School Fees</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="getThemeColor">mdi-credit-card</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{getCurrency}} {{studentFinance.total_due}}</v-list-item-title>
                    <v-list-item-subtitle>Total Due</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="getThemeColor">mdi-credit-card-plus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{getCurrency}} {{totalPaid}}</v-list-item-title>
                    <v-list-item-subtitle>Total Paid</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider inset></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon :color="getThemeColor">mdi-credit-card-minus</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{getCurrency}} {{balanceDueYear}}</v-list-item-title>
                    <v-list-item-subtitle>Total Outstanding</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex class="mx-4" xs12 md8>
            <v-row>
              <v-card class="mx-4 mt-10" elevation="12">
                <v-img
                  class="mt-4 mb-14 mx-10"
                  :src="getApiUrl+'/images/bitspay/payfast_trans.png'"
                ></v-img>
                <form action="https://www.payfast.co.za/eng/process" method="post">
                  <input type="hidden" name="merchant_id" id="merchant_id" />
                  <input type="hidden" name="merchant_key" id="merchant_key" />
                  <input type="hidden" name="return_url" id="return_url" />
                  <input type="hidden" name="cancel_url" id="cancel_url" />
                  <input type="hidden" name="notify_url" id="notify_url" />
                  <v-row v-if="student != null">
                    <input
                      readonly
                      class="mx-auto my-4"
                      name="name_last"
                      :value="student.lname +' '+student.fname"
                      :style="cssStyle"
                    />
                  </v-row>
                  <v-row v-if="student != null">
                    <input
                      readonly
                      class="mx-auto my-4"
                      name="item_name"
                      :value="student.sid"
                      :style="cssStyle"
                    />
                  </v-row>
                  <v-row v-if="student != null">
                    <v-checkbox
                      v-for="(futureBilling,index) in futureBillings"
                      :key="index"
                      class="mx-auto my-4"
                      :label="futureBilling.description + ' [ ' + getCurrency+ futureBilling.amount + ' ]'"
                      :style="cssStyle"
                      v-model="fbInfo"
                      :value="futureBilling.id+'|'+futureBilling.amount+'|'+futureBilling.description"
                    ></v-checkbox>
                  </v-row>
                  <v-row v-if="student != null">
                    <input
                      class="mx-auto my-4"
                      :style="cssStyle"
                      v-model="selectedCat"
                      placeholder="Other Payment eg. School Fees"
                      list="categories"
                    />
                    <datalist id="categories">
                      <option
                        v-for="(category,i) in categories"
                        :key="i+Math.random()+Math.random()"
                        :selected="i == 0"
                        :value="category.id+' | '+category.name"
                      >{{category.name}}</option>
                    </datalist>
                  </v-row>
                  <v-row>
                    <input
                      v-if="studentProfile != null && student != null"
                      class="mx-auto my-4"
                      label="Amount"
                      v-model="amount"
                      placeholder="100.00"
                      :style="cssStyle"
                    />
                  </v-row>

                  <v-row v-if="studentProfile != null && student != null">
                    <input type="hidden" name="amount" id="amount" />
                    <input type="hidden" name="item_name" id="item_name" />
                    <v-btn
                      :disabled="totalAmount <= 0"
                      class="mx-auto my-4"
                      type="submit"
                      color="success"
                      rounded
                      @click="recordPayment()"
                    >Pay {{getCurrency}}{{totalAmount}}</v-btn>
                  </v-row>
                </form>
              </v-card>
            </v-row>
          </v-flex>
        </v-layout>
      </div>
    </DashboardHeader>
  </div>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";

export default {
  components: { DashboardHeader, Loader },
  computed: {
    totalAmount() {
      let total = 0;
      if (this.fbInfo != null) {
        this.fbInfo.forEach(fb => {
          total += Number(fb.split("|")[1]);
        });
      }
      return Number(total) + Number(this.amount);
    },
    fullName() {
      return this.student.lname + " " + this.student.fname;
    },
    getDomain() {
      const domain = window.location.hostname;
      if (domain.includes("http")) {
        return domain;
      } else {
        return "https://" + domain;
      }
    },
    totalDue() {
      return this.openingBalance;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    cssStyle() {
      return {
        outline: "none",
        border: "none",
        "border-bottom": `2px solid ${this.getThemeColor}`,
        width: "60%"
      };
    }
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-bitspay-credentials", this.getAccessToken)
      .then(bitspay => {
        if (Object.entries(bitspay).length > 0) {
          this.merchantId = bitspay.merchant_id;
          this.merchantKey = bitspay.merchant_key;
          axios
            .getData("/auth/get-all-income-categories", this.getAccessToken)
            .then(categories => {
              this.categories = categories;
              this.getStudentMethod(this.getCurrentUser.sid);
            });
        } else {
          this.$store.commit("setLoader", false);
        }
      });
  },
  data: () => ({
    token: null,
    categories: [],
    selectedCat: null,
    futureBillings: [],
    fbInfo: [],
    amount: null,
    merchantId: null,
    merchantKey: null,
    studentProfile: null,
    student: null,
    studentFinance: null,
    statementComments: null,
    openingBalance: null,
    openingBalanceComment: null,
    curfee: null,
    totalPaid: null,
    balanceDueYear: null
  }),

  methods: {
    recordPayment() {
      this.token = axios.generateToken();
      document.getElementById("item_name").value = this.fullName;
      document.getElementById("amount").value = this.totalAmount;
      document.getElementById("merchant_id").value = this.merchantId;
      document.getElementById("merchant_key").value = this.merchantKey;

      document.getElementById("notify_url").value =
        this.getDomain + "/notify-payment";

      document.getElementById("return_url").value =
        this.getDomain + "/payment-successful?token=" + this.token;
      document.getElementById("cancel_url").value =
        this.getDomain + "/cancel-payment";
      if (
        this.selectedCat == null &&
        this.amount == null &&
        this.fbInfo.length < 1
      ) {
        alert(
          "Aleast You Must Pay For 1 Item. \nSelect Description and Enter an Amount!"
        );
        event.preventDefault();
      } else {
        const data = {
          sid: this.student.sid,
          emis: this.getCurrentUser.emis,
          student: this.student,
          selectedCat: this.selectedCat,
          amount: this.amount,
          totalAmount: this.totalAmount,
          fbInfo: this.fbInfo,
          studentFinance: this.studentFinance,
          token: this.token
        };

        axios
          .postDataWithToken(
            "/auth/insert-payment-details",
            data,
            this.getAccessToken
          )
          .then(response => {
            const nt = response;
          });
      }
    },

    getStudentMethod(sid) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-student-profile",
          { sid },
          this.getAccessToken
        )
        .then(studentProfile => {
          if (studentProfile == "not found") {
            this.$store.commit("setLoader", false);
          } else {
            this.futureBillings = studentProfile.finance_info.future_billings;
            this.studentProfile = studentProfile;
            this.student = studentProfile.student;
            this.$store.commit("setCurrentStudent", studentProfile.student);
            this.$store.commit("setCurrentStudentProfile", studentProfile);
            this.studentFinance = studentProfile.finance_info;

            this.statementComments = studentProfile.statement_comments;
            this.openingBalance = studentProfile.finance_info.op;
            this.openingBalanceComment = studentProfile.finance_info.comment;
            this.curfee = studentProfile.finance_info.curfee;
            this.totalPaid = studentProfile.finance_info.all_pay_sum;
            this.balanceDueYear = studentProfile.finance_info.balance_due_year;

            this.$store.commit("setLoader", false);
          }
        });
    }
  }
};
</script>

<style>
</style>